import React, { useEffect, useState } from "react";

import {
  QuizModuleId,
  // quizModuleIds
} from "@common";
import {
  getAttemptedQuizModuleIds,
  getCompletedQuizModuleIds,
  getTotalAmountCorrectAnswers,
} from "@natklok/util/questionUtils";
import getTotalAmountQuestions from "@natklok/util/getTotalAmountQuestions";
import { useSettings } from "@natklok/hooks/useSettings";
import { useQuestions } from "@natklok/hooks/useQuestions";
import { useQuizModules } from "@natklok/hooks/useQuizModules";

export const QuizModuleContext = React.createContext<{
  currentQuizModule: QuizModuleId;
  setCurrentQuizModule: React.Dispatch<React.SetStateAction<QuizModuleId>>;
  totalAmountOfQuestions: number;
  previousTotalAmountCorrect: number;
  getTotalAmountCorrect: () => number;
  resetPreviousAmountCorrect: () => void;
  getIsFirstQuizModuleComplete: () => boolean;
  getAllQuizModulesComplete: () => boolean;
}>({
  currentQuizModule: "general",
  setCurrentQuizModule: () => null,
  totalAmountOfQuestions: 0,
  previousTotalAmountCorrect: 0,
  getTotalAmountCorrect: () => 0,
  resetPreviousAmountCorrect: () => null,
  getIsFirstQuizModuleComplete: () => false,
  getAllQuizModulesComplete: () => false,
});

export const QuizModuleProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const settings = useSettings();

  const { data: questionsData } = useQuestions();
  const questions = questionsData ?? [];

  const { data: quizModulesData, quizModuleIds } = useQuizModules();

  // TODO COMPLETE: Add questions
  // TODO COMPLETE: Add quiz modules
  const [totalAmountOfQuestions, setTotalAmountOfQuestions] = useState(
    getTotalAmountQuestions({ settings, questions, quizModules: {} })
  );
  useEffect(() => {
    const quizModules = quizModulesData ?? {};
    setTotalAmountOfQuestions(getTotalAmountQuestions({ settings, questions, quizModules }));
  }, [settings, questions, quizModulesData]);

  const [currentQuizModule, setCurrentQuizModule] = useState<QuizModuleId>("general");
  const [previousAmountCorrect, setPreviousAmountCorrect] = useState<number>(
    getTotalAmountCorrectAnswers()
  );

  const resetPreviousAmountCorrect = () => {
    setPreviousAmountCorrect(getTotalAmountCorrectAnswers());
  };

  const getTotalAmountCorrect = () => {
    return getTotalAmountCorrectAnswers();
  };

  const getIsFirstQuizModuleComplete = () => {
    // TODO COMPLETE: Add quiz modules
    return getAttemptedQuizModuleIds({ quizModules: quizModulesData ?? {} }).length === 1;
  };

  const getAllQuizModulesComplete = () => {
    // TODO COMPLETE: Add questions
    // TODO COMPLETE: Add quiz modules
    // TODO COMPLETE: Add quiz module IDs
    return (
      getCompletedQuizModuleIds({ settings, questions, quizModules: quizModulesData ?? {} })
        .length === quizModuleIds.length
    );
  };

  return (
    <QuizModuleContext.Provider
      value={{
        currentQuizModule,
        setCurrentQuizModule,
        totalAmountOfQuestions,
        previousTotalAmountCorrect: previousAmountCorrect,
        getTotalAmountCorrect,
        resetPreviousAmountCorrect,
        getIsFirstQuizModuleComplete,
        getAllQuizModulesComplete,
      }}
    >
      {children}
    </QuizModuleContext.Provider>
  );
};
